import { useCallback, useEffect, useRef } from 'react';
import { useDocumentVisibility, useLatest, useUpdateEffect } from 'ahooks';
import { Updater } from './updater';
import type { UpdaterOptions } from './updater';

type VoidFunc = () => void;

interface UseUpdateProgramOptions extends UpdaterOptions {
  onUpdate: (updateLog: string | null) => void;
}

const useUpdateProgram = (options?: UseUpdateProgramOptions) => {
  const updaterRef = useRef<Updater | null>(null);
  /** 获取最新的 onUpdate 函数 */
  const latestOnUpdateRef = useLatest(options?.onUpdate);
  const visibility = useDocumentVisibility();

  useEffect(() => {
    updaterRef.current = new Updater(options);

    updaterRef.current.once('update', (updatelog?: string) => {
      latestOnUpdateRef.current?.(updatelog || null);
      updaterRef.current?.clear();
    });

    return () => {
      updaterRef.current?.clear();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useUpdateEffect(() => {
    if (visibility === 'visible') {
      handleCompare();
    }
  }, [visibility]);

  const clear = useCallback(() => {
    updaterRef.current?.clear();
  }, []);

  const handleCompare = useCallback(() => {
    updaterRef.current?.handleCompare();
  }, []);

  return {
    clear,
    handleCompare,
  };
};

export default useUpdateProgram;
